<template>
  <v-app-bar app flat dark class="glass-app-bar">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-app-bar-nav-icon
          v-bind="attrs"
          v-on="on"
          @click.stop="menu = !menu"
        ></v-app-bar-nav-icon>
      </template>
      <span>Menú</span>
    </v-tooltip>

    <v-navigation-drawer
      v-model="menu"
      app
      absolute
      temporary
      class="glass-drawer"
      dark
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>{{
              $store.state.usuario.usuario
            }}</v-list-item-title>
            <v-list-item-subtitle>{{
              $store.state.usuario.institucion.nombreInstitucion
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list dense>
        <v-list-group
          no-action
          prepend-icon="mdi-calendar-clock"
          v-if="$store.getters.tieneRol(3)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Turnos</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-if="$vuetify.breakpoint.width > 800"
            to="/turnos/gestion_turnos_wide"
            link
          >
            <v-list-item-title>Agenda Semanal</v-list-item-title>
          </v-list-item>

          <v-list-item v-else to="/turnos/gestion_turnos_semana" link>
            <v-list-item-title>Agenda Semanal</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-for="(turno, i) in turnos"
            :key="i"
            :to="turno[1]"
            link
          >
            <v-list-item-title v-text="turno[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          prepend-icon="mdi-cogs"
          v-if="$store.getters.tieneRol(9)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Configuraciones</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(conf, i) in confTurnosFiltrados"
            :key="i"
            :to="conf[1]"
            link
          >
            <v-list-item-title v-text="conf[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          prepend-icon="mdi-trophy"
          v-if="$store.getters.tieneRol(4)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Competiciones</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(gest, i) in competiciones"
            :key="i"
            :to="gest[1]"
            link
          >
            <v-list-item-title v-text="gest[0]"></v-list-item-title>
          </v-list-item>
          <v-list-item v-if="renderizaRankings" to="/rankings" link>
            <v-list-item-title v-text="'Rankings'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          prepend-icon="mdi-account-multiple"
          v-if="$store.getters.tieneRol(8)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Gestión</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(gest, i) in gestion" :key="i" :to="gest[1]" link>
            <v-list-item-title v-text="gest[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          prepend-icon="mdi-currency-usd"
          v-if="$store.getters.tieneRol(5)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Caja</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(caja, i) in cajas" :key="i" :to="caja[1]" link>
            <v-list-item-title v-text="caja[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          prepend-icon="mdi-package-variant"
          v-if="$store.getters.tieneRol(10)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Stock</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(st, i) in stock" :key="i" :to="st[1]" link>
            <v-list-item-title v-text="st[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          prepend-icon="mdi-chart-bar"
          v-if="$store.getters.tieneRol(7)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Estadísticas</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(est, i) in estadisticas"
            :key="i"
            :to="est[1]"
            link
          >
            <v-list-item-title v-text="est[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          no-action
          v-if="
            this.$store.state.usuario.institucion.esEmpresa &&
            $store.getters.tieneRol(7)
          "
          prepend-icon="mdi-chart-bar"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Estadísticas</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(est, i) in reportes" :key="i" :to="est[1]" link>
            <v-list-item-title v-text="est[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>

        <v-list-group
          no-action
          prepend-icon="mdi-key-variant"
          v-if="$store.getters.tieneRol(6)"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cuenta</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(conf, i) in confs" :key="i" :to="conf[1]" link>
            <v-list-item-title v-text="conf[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout()" block>
            <v-icon left>mdi-power-standby</v-icon>
            Cerrar Sesión</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
    <v-divider vertical></v-divider>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-3" icon small v-bind="attrs" v-on="on" to="/Home">
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </template>
      <span>Página de Inicio</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-2"
          icon
          x-small
          v-bind="attrs"
          v-on="on"
          @click="cambiarContrasena"
        >
          <v-icon>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <span>Cambiar Contraseña</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-2" v-bind="attrs" v-on="on" icon small @click="logout">
          <v-icon>mdi-power-standby</v-icon>
        </v-btn>
      </template>
      <span>Cerrar Sesión</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <span class="mr-6">
      <v-menu offset-y class="notification-menu">
        <template v-slot:activator="{ on, attrs }">
          <v-badge
            :content="
              getListaRecordatorios.filter((item) => !item.leido).length
            "
            color="red"
            overlap
            :class="{
              notification: true,
              'sin-notificaciones': !getListaRecordatorios.filter(
                (item) => !item.leido,
              ).length,
            }"
          >
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-bell</v-icon>
            </v-btn>
          </v-badge>
        </template>

        <v-card min-width="300" class="notification-card">
          <v-list>
            <template v-if="getListaRecordatorios.length">
              <div
                class="notification-list"
                style="overflow-y: auto; max-height: 500px"
              >
                <v-list-item
                  v-for="(notification, index) in getListaRecordatorios"
                  :key="index"
                  :class="{ 'no-leido': !notification.leido }"
                  @click="openNotification(notification)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{
                      notification.titulo
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="text-truncate">
                      {{ notification.texto }}
                      <v-row v-if="notification.usuarioCreador">
                        <v-col cols="12">
                          <span>
                            Notificacion creada por:
                            {{ notification.usuarioCreador }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click.stop="openNotification(notification)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </template>
            <v-list-item v-else>
              <v-list-item-content>
                <v-list-item-title
                  style="text-align: center; font-size: 1rem; font-weight: 600"
                >
                  No hay notificaciones
                </v-list-item-title></v-list-item-content
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  style="text-align: center; font-size: 1rem; font-weight: 600"
                >
                  <v-btn color="warning" @click="showNuevoRecordatorio = true"
                    >Crear Notificación</v-btn
                  >
                </v-list-item-title></v-list-item-content
              >
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </span>
    <span class="app-version">v1.36.0</span>

    <CambiarContrasena
      :visible="showCambiarContrasena"
      :usuario="usuario"
      @close="showCambiarContrasena = false"
    ></CambiarContrasena>
    <NuevoRecordatorio
      :visible="showNuevoRecordatorio"
      :notificaFlag="true"
      @close="showNuevoRecordatorio = false"
      @recordatorioRegistrado="showNuevoRecordatorio = false"
    ></NuevoRecordatorio>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ selectedNotification.titulo }}</v-card-title>
        <v-card-text>
          {{ selectedNotification.texto }}
          <v-row v-if="selectedNotification.usuarioCreador">
            <v-col cols="12">
              Notificación creada por: {{ selectedNotification.usuarioCreador }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import CambiarContrasena from "../Cuenta/CambiarContrasena.vue";
import NuevoRecordatorio from "../Recordatorios/NuevoRecordatorio.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "@/axios-auth.ts";
import { getDeportesConfig } from "@/utils/models";

export default {
  data() {
    return {
      showNuevoRecordatorio: false,
      dialog: false,
      selectedNotification: {},
      showCambiarContrasena: false,
      menu: false,
      turnos: [
        ["Agenda Diaria", "/turnos/gestion_turnos"],
        ["Buscar Turnos", "/turnos/buscar_turnos"],
        ["Buscar Turnos Eliminados", "/turnos/buscar_turnos_eliminados"],
        ["Reporte Inasistencias", "/turnos/reporte_inasistencias"],
      ],
      confTurnos: [
        ["Cronogramas", "/gestion/cronogramas"],
        ["Feriados y Cancelaciones", "/gestion/feriados_y_cancelaciones"],
        ["Tipos de Turno", "/gestion/tipos_turno"],
      ],
      gestion: [
        ["Canchas", "/gestion/canchas"],
        ["Jugadores", "/gestion/jugadores"],
        ["Profesores", "/gestion/profesores"],
      ],
      competiciones: [
        ["Competiciones (Torneos y Ligas)", "/lista-competiciones"],
      ],
      cajas: [
        ["Gestión de Movimientos de Caja", "/caja/movimientos"],
        ["Cajas (Multi-Caja)", "/caja/cajas"],
        ["Liquidación Profesores", "/caja/liquidaciones"],
        ["Cierre de Caja", "/caja/cierres"],
        ["Cuentas Corrientes", "/caja/cuentas_corrientes"],
        ["Saldos Pendientes", "/caja/saldos_pendientes"],
      ],
      stock: [["Productos", "/stock/productos"]],
      estadisticas: [["Dashboard", "/estadisticas/dashboard"]],
      confs: [
        ["Configurar Complejo", "/cuenta/complejo"],
        ["Gestión de Usuarios", "/cuenta/usuarios"],
      ],
      group: null,
      usuario: null,
      institucion: null,
    };
  },
  computed: {
    ...mapGetters(["getListaRecordatorios"]),
    deportes() {
      return getDeportesConfig(
        this.$store.state.usuario.institucion.idInstitucion,
      ).deportes;
    },
    // Filtrar confTurnos según el usuario
    confTurnosFiltrados() {
      // Tipos de Turno visible para todos los administradores
      return this.confTurnos;
    },
    renderizaRankings() {
      return this.deportes.some(
        (d) => d.value === "Padel" || d.value === "Tenis",
      );
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    ...mapMutations(["marcarComoLeido"]),
    async openNotification(notification) {
      this.marcarComoLeido(notification.idRecordatorio);
      await axios.get("/Usuario/MarcarRecordatorioComoLeido", {
        params: {
          idRecordatorio: notification.idRecordatorio,
          usuario: this.$store.state.usuario.usuario,
        },
      });
      this.selectedNotification = notification;
      this.dialog = true;
    },
    logout() {
      this.$store.dispatch("logout");
    },
    cambiarContrasena() {
      this.showCambiarContrasena = true;
    },
  },
  created() {
    this.usuario = this.$store.state.usuario.usuario.toString().trim();
    this.institucion = this.$store.state.usuario.institucion.nombreInstitucion
      .toString()
      .trim();
  },
  components: {
    CambiarContrasena,
    NuevoRecordatorio,
  },
};
</script>
<style scoped>
.app-version {
  color: white;
  font-size: 0.75rem;
  margin-right: 1.5rem;
}
::v-deep .notification .v-badge__badge {
  inset: auto auto calc(100% - 16px) calc(100% - 22px) !important;
  width: 20px;
  text-align: center;
  padding: 4px 2.5px;
}

.notification-card {
  margin-bottom: 0;
}

::v-deep .notification.sin-notificaciones .v-badge__badge {
  visibility: hidden;
}

::v-deep .notification-card .v-list {
  width: 500px;
}

::v-deep .notification-card .v-list-item.no-leido {
  background-color: #e8e8e8;
}

::v-deep .notification-card .v-list-item {
  cursor: pointer;
}

::v-deep .notification-card .v-list-item:not(:last-child) {
  border-bottom: 0.8px solid lightgray;
}
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}
.glass-app-bar {
  backdrop-filter: blur(14px);
  background: rgba(20, 35, 45, 0.85);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.glass-drawer {
  backdrop-filter: blur(16px);
  background: rgba(15, 30, 40, 1);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  width: 290px !important;
}
.glass-app-bar .v-btn {
  color: rgba(255, 255, 255, 0.85);
}

.glass-app-bar .v-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}
</style>
